// Symbole de la marque Linea (charte d'août 2026, piste « le total souligné ») :
// deux lignes d'écriture alignées à droite comme une colonne de montants, puis le
// double trait que le comptable tire sous un total. Monochrome, il prend la
// couleur du texte (currentColor) : blanc sur le rail, noir sur fond clair.

interface MarqueLineaProps {
  taille: number;
  className?: string;
}

export function MarqueLinea({ taille, className }: MarqueLineaProps) {
  return (
    <svg
      width={taille}
      height={taille}
      viewBox="0 0 32 32"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <rect x="11" y="5" width="16" height="3.4" rx="1.7" />
      <rect x="16" y="11" width="11" height="3.4" rx="1.7" />
      <rect x="5" y="19" width="22" height="2.6" rx="1.3" />
      <rect x="5" y="24.4" width="22" height="2.6" rx="1.3" />
    </svg>
  );
}
